import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { quizFormInputSetStateCallback } from "../../HelperFunctions/quizHelperFunctions";
import useUserInfo from "../../hooks/useUserInfo";
import { useQuizParticipateMutation } from "../../redux/features/quiz/quizApi";
import SingleQuiz from "./SingleQuiz";


export default function QuizForm({ quizzes, isQuizMark }) {
    const navigate = useNavigate()
    const [quizParticipate, { isLoading, isSuccess }] = useQuizParticipateMutation();
    const user = useUserInfo()
    const [input, setInput] = useState([])


    const changeHandler = (e) => {
        const identifier = JSON.parse(e.target.name)
        const value = e.target.checked
        setInput(quizFormInputSetStateCallback(identifier, value))
    }

    const submitHandler = (e) => {
        e.preventDefault();
        const quizCorrect = quizzes.reduce((totalCorrect, current) => {

            const answeredOptionsForCurrentId = input.filter(item => item.identifier.quizId === current.id)


            const correctOptions = current.options.reduce((total, cur) => {
                if (cur.isCorrect) {

                    const isAllOptionsCorrect = answeredOptionsForCurrentId.some(item => item.identifier.optionId === cur.id && item.answer)

                    return isAllOptionsCorrect ? total + 1 : total

                } else {

                    const isAllOptionsFalse = !answeredOptionsForCurrentId.some(item => item.identifier.optionId === cur.id && item.answer)

                    return isAllOptionsFalse ? total + 1 : total

                }
            }, 0)

            return (correctOptions === 4) ? totalCorrect + 1 : totalCorrect

        }, 0)


        quizParticipate({
            student_id: user?.id,
            student_name: user?.name,
            video_id: quizzes[0]?.video_id,
            video_title: quizzes[0]?.video_title,
            totalQuiz: quizzes?.length,
            totalCorrect: quizCorrect,
            totalWrong: quizzes?.length - quizCorrect,
            totalMark: quizzes?.length * Number(process.env.REACT_APP_QUIZ_MARK),
            mark: quizCorrect * Number(process.env.REACT_APP_QUIZ_MARK)
        })
    }

    useEffect(() => {
        if (isSuccess) {
            navigate("/leaderboard")
        }
    }, [isSuccess, navigate])
    return (
        <form onSubmit={submitHandler}>
            <div className="space-y-8 ">
                {quizzes.map((quiz, index) => <SingleQuiz isQuizMark={isQuizMark} changeHandler={changeHandler} key={quiz.id} quizNumber={index + 1} quiz={quiz} />)}
            </div>

            {!isQuizMark && <button disabled={isLoading}
                className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 ">Submit</button>}
        </form>
    )
};